
import { faCalendar, faClock } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { orderListDetailApi } from '../../Api/SupplierServices'
import EachComment from '../EachComment/EachComment'
import Factor from '../Factor/Factor'
import Modal from '../Modal/Modal'
import Style from './CommentList.module.css'
const CommentList = ({data,updateList}) => {
        
    const [purchased,setPurchased]=useState(false)
    const[orderInfo,setOrderInfo]=useState()

    const getOrderListHandler=(id)=>{
        setPurchased(true)
        orderDetail(id)
    }
    const orderDetail=async(id)=>{
        const data=await orderListDetailApi(id)
        setOrderInfo(data)
    }
    
    return (
        <ul className={Style.ComponentHolder}>
            <Modal show={purchased} modalClose={()=>setPurchased(false)} translate={20}>
                <div className={Style.DateOrder}>
                    
                    <h4><FontAwesomeIcon icon={faCalendar}/>{orderInfo===undefined||orderInfo.date===null?null: orderInfo.date.split(' ')[0]}</h4>
                    <p><FontAwesomeIcon icon={faClock}/>{orderInfo===undefined||orderInfo.date===null?null: orderInfo.date.split(' ')[1]}</p>
                   
                </div>
                <Factor data={orderInfo}/>
            </Modal>
            {
                data.slice(0).reverse().map(item=>{
                    return(
                        <EachComment key={item.id} item={item} updateList={updateList} getOrderListHandler={getOrderListHandler}/>
                    )
                })
            }
            
        </ul>
    )
}

export default CommentList
